import React from 'react';
import LayoutProvider from './layout';

// eslint-disable-next-line react/prop-types,react/display-name
export default ({ element, props }) => {
    return <LayoutProvider { ...props }>{element}</LayoutProvider>
}